import { chatbotApi } from './chatbotApi';

export const {
  useChatbotMutation,
  useClearChatbotMutation,
  useGetChatbotQuery,
  useLazyGetChatbotQuery,
} = chatbotApi;

export { chatbotApi };
